<template>
  <div
    class="lg:px-20 md:px-12 px-4 lg:py-20 md:py-12 lg:mb-0 md:mb-0 mb-12 md:mt-0 lg:mt-0 mt-20 bg-white"
  >
    <div
      class="mt-4 lg:w-7/12 md:w-11/12 w-4/5 m-auto lg:text-center md:text-center textleft"
    >
      <p class="">
        Poetry & Conversation is a partnership between Kingston Carers and
        Rosetta Life.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        The next video masterclass will be uploaded at the end of January . It
        will be a poetry workshop led by award winning artist, Lucinda Jarrett,
        artistic director of Rosetta Life Lucinda Jarrett has facilitated poetry
        and storytelling and and song workshops for the past twenty years.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        We invite you to make something to represent you, how you care and how
        people perceive care and the role of carers across society.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        She worked in children and adult hospice care, with bereaved families,
        with older adults living with the effects of brain injury and stroke,
        with families living with dementia and teenagers facing mental health
        challenges.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        Lucinda likes to work with the art of conversation and speech and find
        the music and the poetry in the patterns and images of everyday
        language.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        Lucinda will lead this next Masterclass in partnership with Joe Lambert,
        a carer who is also an amazing poet.
      </p>
      <p class="lg:mt-2 md:mt-2 mt-2 sm-fsize14">
        Here is an example of one of her poems:
      </p>
    </div>

    <div
      class="shadow-lg rounded-md lg:w-7/12 md:w-10/12 w-4/5 m-auto mt-4 text-left"
    >
      <h1 class="text-black bold pl-6 pt-5 mb-4">Alliance</h1>
      <p class="pl-6 sm-fsize14">
        Self-care for carers?<br />
        I absolutely agree <br />
        But don't underestimate me <br />
        Care-giver? <br />
        More like care-river <br />
        I must be doing something right <br />
        As I'm still here <br />
        Deep in the trenches <br />
        A soldier in an endless war <br />
        The enemy's intangible <br />
        Shifts and re-invents itself <br />
        Allowing for nothing <br />
        But uncertainty <br />
        I fight for love and will endure <br />
        So don't assume <br />
        I'm in any way hopeless <br />
        I'm a survivor too <br />
        Please don't dismiss me as disastrous <br />
        Just because I'm not in an office <br />
        With make up on <br />
        Like you <br />
        What self-care is there <br />
        Whilst in a crisis <br />
        In between the 15 minute checks? <br />
        Time out for rest's not on my radar <br />
        What do you expect? <br />
        I run on autopilot <br />
        Doing what's required <br />
        With love and dignity I work 24/7 <br />
        With no support, no breaks <br />
        So please don't underestimate me <br />
        Work with me <br />
        Respect me <br />
      </p>

      <p class="pl-6 pt-6 pb-6 sm-fsize14">
        ©Jo Lambert 2021
        <a href="mailto:@poetry_byjo" class="underline textcolor"
          >@poetry_byjo</a
        >
      </p>
    </div>
    <div class="lg:w-7/12 md:w-7/12 w-4/5 m-auto text-left mt-6 sm-fsize14">
      <p>
        Participants will learn how to create short poems from conversations.
        Working with every day <br />
        speech and the music of our own voices, we will demystify the art of
        poetry and make it accessible and easy to approach.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.textcolor {
  color: #4a0a4b;
}
.bg-color {
  background-color: #94abca;
}
.heightWidth {
  height: 25rem;
  width: 80%;
}
.textleft {
  text-align: left !important;
}
</style>
